module.exports = __webpack_public_path__ + "static/media/Untitled-1-2.daa45b7b.jpg";